import { FieldArray, Form, Formik, getIn, Field } from 'formik';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import * as yup from 'yup';
import {
  Row,
  Col,
  B1,
  H6,
  P2,
  CheckBox,
  B2,
  P1,
  Modal,
  Button,
  SelectDropdown,
  DateInput,
  Input,
} from 'pfm-ui-components';
import { pxToRem } from '../../../../styles/utils';
import { up } from 'styled-breakpoints';
import * as constants from '../../../../constants/NomineeModal';
import { checkBoxStyling, dropDownStyling, inputStylingProps } from '../../../../styles/common';
import * as ErrorMessage from '../../../../constants/ErrorMessages';
import { formatValueForDropDown, formatToEvent, getRelationshipDropdownDetails } from './util';
import { useState } from 'react';
import _ from 'lodash';
var moment = require('moment');
import { nomineeDetailsValidation, guardianDetailsValidation } from '../../../../utils/formValidationHelper';
import {
  REGEX_NUMBER_INPUT_ONLY_STARTING_FROM_1,
  CHARACTER_INPUT_AND_EMPTY_SPACE_ONLY,
  NO_BLANK_SPACE_START_END,
} from '../../../../constants/common';
import { RelationShipCodes } from '../../../../pages/transact/invest';
import { convertArrayOfObjectToDropDownStylingBasedOnDifferentLabelAndValueName } from '../utils';
// import { CHARACTER_INPUT_AND_EMPTY_SPACE_ONLY, NUMBER_INPUT_ONLY } from '../../../../constants/common';
import PlusBurgundy from '../../../../assets/icons/plus-burgundy.svg';
import { StyledAlertModal } from '../../../../pages/transact/invest';
import { NEW_NOMINEE_DECLARATION_MESSAGE, NOMINEE_DECLARATION_ERROR } from '../../../../constants/investTransactPage';
import { renameFundHouseBasedOnFundHouseId } from '../../../../utils/fundhouse';
1;
interface NomineeModalProps {
  isOpen: boolean;
  onCloseModal: Function;
  accountHolder: string;
  onNomineeDetailsSubmit: Function;
  nomineesDetails: any;
  maxNominee: any;
  relationShipCodeDetails: Array<RelationShipCodes>;
  relationShipCodeObject: object;
  onAddNomineeClick?: Function; // Added only for GA event call
  onRemoveNomineeClick?: Function; // Only for GA module
  fundHouseId: string;
  nomineeDeclarationOptInChecked: boolean;
  setNomineeDeclarationOptInChecked: Function;
  setNomineeDeclarationOptInError: Function;
  nomineeDeclarationOptInError: boolean;
  setNomineeDetailsPresent: Function;
  shouldSendOtp?: Function;
  setIsModalOpen?: Function;
}

const NomineeInputRef = React.createRef();
const RelationShipREf = React.createRef();
const dateOfBirthRef = React.createRef();
const shareRef = React.createRef();

const isMinor = (dateOfBirth: any, isNominee: boolean) => {
  let years = moment().diff(dateOfBirth, 'years');
  if (years < 18 && isNominee) {
    return true;
  }
  return false;
};

const NomineeDetails = (
  isNominee: boolean,
  index: number,
  values: any,
  errors: any,
  handleChange: Function,
  handleBlur: Function,
  handleShowGuardian: Function,
  noOfNominee: number,
  setFieldValue: Function,
  touched: any,
  accountHolder: string,
  setFieldError: Function,
  setFieldTouched: Function,
  setOpenErrorModal: Function,
  setErrorMessageShownInModal: Function,
  relationShipCodeDetails: Array<RelationShipCodes>,
  relationShipCodeObject: object
) => {
  const handleDropDownChange = (fieldName: string, value: string) => {
    const event = {
      target: {
        name: fieldName,
        value: value,
      },
    };
    handleChange(event);
  };

  const errorMessage = (name: string, errors: any, touched: any) => {
    const error = getIn(errors, name);
    const touch = getIn(touched, name);
    return touch && error ? error : null;
  };

  const onNomineeNameChange = (event) => {
    const characterInputOnlyRegex = NO_BLANK_SPACE_START_END;
    let nomineeInput = event?.target?.value;
    if (nomineeInput === '' || characterInputOnlyRegex.test(nomineeInput)) {
      if (nomineeInput?.trim()?.toLowerCase() === accountHolder?.toLowerCase()) {
        setErrorMessageShownInModal(ErrorMessage.NOMINEE_NAME_SAME_AS_ACCOUNT_HOLDER_NAME_ERROR);
        setOpenErrorModal(true);
        setFieldValue(`nominees.${index}.nomineeDetails.name`, '');
      } else {
        setFieldValue(`nominees.${index}.nomineeDetails.name`, nomineeInput);
      }
    }
  };

  const onGuardianNameChange = (event) => {
    const characterInputOnlyRegex = CHARACTER_INPUT_AND_EMPTY_SPACE_ONLY;
    if (event?.target?.value === '' || characterInputOnlyRegex.test(event?.target?.value)) {
      if (
        values?.nominees[index]?.nomineeDetails?.name &&
        event?.target?.value?.toLowerCase() === values?.nominees[index]?.nomineeDetails?.name?.toLowerCase()
      ) {
        setErrorMessageShownInModal(ErrorMessage.NOMINEE_NAME_GUARDIAN_NAME_SAME_ERROR);
        setOpenErrorModal(true);
      } else {
        setFieldValue(`nominees.${index}.guardian.name`, event?.target?.value);
      }
    }
  };

  const onShareChange = (event) => {
    if (event?.target?.value === '' || REGEX_NUMBER_INPUT_ONLY_STARTING_FROM_1.test(event?.target?.value)) {
      // handleChange(event);
      setFieldValue(event?.target?.name, event?.target?.value);
    }
  };

  return (
    <NomineeDetailWrapper>
      <InputWrapper enable={isNominee} addRightPadding={true}>
        <StyledInput
          id={`nomineeName${index}`}
          label={constants.NOMINEE}
          name={`nominees.${index}.nomineeDetails.name`}
          className="inputField-v2"
          inputStylingProps={inputStylingProps}
          placeholder={constants.ENTER_NAME}
          innerRef={NomineeInputRef}
          onBlur={handleBlur}
          onChange={onNomineeNameChange}
          value={values?.nominees[index]?.nomineeDetails?.name}
          error={
            errorMessage(`nominees.${index}.nomineeDetails.name`, errors, touched)
              ? errorMessage(`nominees.${index}.nomineeDetails.name`, errors, touched)
              : ''
          }
        />
      </InputWrapper>
      <InputWrapper enable={!isNominee} addRightPadding={true}>
        <StyledInput
          id={`guardianName${index}`}
          label={constants.GUARDIAN}
          name={values?.nominees[index]?.guardian && `nominees.${index}.guardian.name`}
          className="inputField-v2"
          inputStylingProps={inputStylingProps}
          placeholder={constants.ENTER_NAME}
          innerRef={NomineeInputRef}
          onBlur={handleBlur}
          onChange={onGuardianNameChange}
          value={values?.nominees[index]?.guardian && values?.nominees[index]?.guardian?.name}
          error={
            errorMessage(`nominees.${index}.guardian.name`, errors, touched)
              ? errorMessage(`nominees.${index}.guardian.name`, errors, touched)
              : ''
          }
        />
      </InputWrapper>
      <SelectDropDownWrapper>
        <SelectDropdown
          id={`relationShip${index}`}
          label={constants.RELATIONSHIP}
          name={isNominee ? `nominees.${index}.nomineeDetails.relationShip` : `nominees.${index}.guardian.relationShip`}
          className="dropdown-v2"
          placeholder="Select"
          dropdownStyling={dropDownStyling}
          shouldShowAsterisk={false}
          rotateDropdownIcon={true}
          innerRef={RelationShipREf}
          options={getRelationshipDropdownDetails(relationShipCodeObject)}
          onBlur={handleBlur}
          onChange={(relationship) =>
            handleDropDownChange(
              isNominee ? `nominees.${index}.nomineeDetails.relationShip` : `nominees.${index}.guardian.relationShip`,
              relationship?.value
            )
          }
          error={
            !!errorMessage(
              isNominee ? `nominees.${index}.nomineeDetails.relationShip` : `nominees.${index}.guardian.relationShip`,
              errors,
              touched
            )
          }
          errorMsg={errorMessage(
            isNominee ? `nominees.${index}.nomineeDetails.relationShip` : `nominees.${index}.guardian.relationShip`,
            errors,
            touched
          )}
          value={
            isNominee
              ? values?.nominees[index]?.nomineeDetails?.relationShip &&
                formatValueForDropDown(
                  isNominee
                    ? values?.nominees[index]?.nomineeDetails?.relationShip
                    : values?.nominees[index]?.guardian?.relationShip
                )
              : values?.nominees[index]?.guardian?.relationShip &&
                formatValueForDropDown(
                  isNominee
                    ? values?.nominees[index]?.nomineeDetails?.relationShip
                    : values?.nominees[index]?.guardian?.relationShip
                )
          }
        />
      </SelectDropDownWrapper>

      <DateWrapper>
        <DateInput
          type="date"
          name={isNominee ? `nominees.${index}.nomineeDetails.dateOfBirth` : `nominees.${index}.guardian.dateOfBirth`}
          value={
            isNominee
              ? values?.nominees[index]?.nomineeDetails?.dateOfBirth
                ? new Date(values?.nominees[index]?.nomineeDetails?.dateOfBirth)
                : values?.nominees[index]?.nomineeDetails?.dateOfBirth
              : values?.nominees[index]?.guardian && values?.nominees[index]?.guardian?.dateOfBirth
              ? new Date(values.nominees[index].guardian.dateOfBirth)
              : values?.nominees[index]?.guardian?.dateOfBirth
          }
          label={constants.DATE_OF_BIRTH}
          placeholder="DD/MM/YYYY"
          // onBlur={handleBlur}
          onChange={(date) =>
            isNominee
              ? handleShowGuardian(
                  handleChange,
                  `nominees.${index}.nomineeDetails.dateOfBirth`,
                  date,
                  isNominee,
                  values,
                  index,
                  setFieldValue,
                  setFieldError,
                  setFieldTouched
                )
              : handleShowGuardian(
                  handleChange,
                  `nominees.${index}.guardian.dateOfBirth`,
                  date,
                  false,
                  values,
                  index,
                  setFieldValue,
                  setFieldError,
                  setFieldTouched
                )
          }
          innerRef={dateOfBirthRef}
          error={
            errorMessage(
              isNominee ? `nominees.${index}.nomineeDetails.dateOfBirth` : `nominees.${index}.guardian.dateOfBirth`,
              errors,
              touched
            )
              ? errorMessage(
                  isNominee ? `nominees.${index}.nomineeDetails.dateOfBirth` : `nominees.${index}.guardian.dateOfBirth`,
                  errors,
                  touched
                )
              : ''
          }
          readOnly={false}
          focusedLabel
        />
        <MinorLabelWrapper enable={isMinor(values?.nominees[index]?.nomineeDetails?.dateOfBirth, isNominee)}>
          <HighlightP2>{constants.MINOR}</HighlightP2>
        </MinorLabelWrapper>
      </DateWrapper>
      <InputWrapper enable={isNominee && noOfNominee > 1} addLeftPadding={true}>
        <Input
          id={`share${index}`}
          label={constants.SHARE}
          name={`nominees.${index}.share`}
          className="inputField-v2"
          placeholder="Enter share"
          inputStylingProps={inputStylingProps}
          innerRef={shareRef}
          value={values?.nominees[index]?.share}
          onChange={onShareChange}
          onBlur={handleBlur}
          maxLength={2}
          error={
            errorMessage(`nominees.${index}.share`, errors, touched)
              ? errorMessage(`nominees.${index}.share`, errors, touched)
              : ''
          }
        />
      </InputWrapper>
    </NomineeDetailWrapper>
  );
};

const Footer = (
  values: any,
  handleChange: Function,
  handleSubmit: Function,
  setNomineeDeclarationOptInChecked: Function,
  nomineeDeclarationOptInChecked: boolean,
  setNomineeDeclarationOptInError: Function,
  nomineeDeclarationOptInError: boolean,
  fundHouseId: string,
  shouldSendOtp: Function,
  setIsModalOpen: Function
) => {
  const handleConfirmClick = async () => {
    if (!nomineeDeclarationOptInChecked) {
      setNomineeDeclarationOptInError(true);
    } else {
      const shouldSend = shouldSendOtp();
      const modalOpen = setIsModalOpen(false);
      if (shouldSend && modalOpen) {
        handleSubmit();
      }
    }
  };
  return (
    <FooterWrapper>
      <NewNomineeDeclarationMessageWrapper>
        <StyledCheckBox
          name="acceptedNomineeTerms"
          labelColor="#4A4A4A"
          checkBoxStyling={checkBoxStyling}
          checked={nomineeDeclarationOptInChecked}
          onChange={() => {
            handleChange(formatToEvent('acceptedNomineeTerms', !values?.acceptedNomineeTerms));
            setNomineeDeclarationOptInChecked(!nomineeDeclarationOptInChecked);
            setNomineeDeclarationOptInError(false);
          }}
        />
        <NomineeDeclarationOptOutAccordionText>
          {NEW_NOMINEE_DECLARATION_MESSAGE(renameFundHouseBasedOnFundHouseId(fundHouseId))}
        </NomineeDeclarationOptOutAccordionText>
      </NewNomineeDeclarationMessageWrapper>
      <NominationDeclarationErrorMessage>
        {nomineeDeclarationOptInError && <StyledErrorMessage>{NOMINEE_DECLARATION_ERROR}</StyledErrorMessage>}
      </NominationDeclarationErrorMessage>
      <br />
      <StyledButton type="submit" primary onClick={handleConfirmClick}>
        {constants.CONFIRM}
      </StyledButton>
    </FooterWrapper>
  );
};
export default function NomineeModal2FA(props: NomineeModalProps) {
  const {
    isOpen,
    onCloseModal,
    accountHolder,
    onNomineeDetailsSubmit,
    nomineesDetails,
    maxNominee,
    relationShipCodeDetails,
    relationShipCodeObject,
    onAddNomineeClick,
    onRemoveNomineeClick,
    nomineeDeclarationOptInChecked,
    setNomineeDeclarationOptInChecked,
    setNomineeDeclarationOptInError,
    nomineeDeclarationOptInError,
    fundHouseId,
    setNomineeDetailsPresent,
    shouldSendOtp,
    setIsModalOpen,
  } = props;
  let data = nomineesDetails || {};
  const [nomineeData, setNominee] = useState([]);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessageShownInModal, setErrorMessageShownInModal] = useState('');
  const [nomineeCount, setNomineeCount] = useState(data?.nominees?.length || 0);

  const initialValues =
    data?.nominees?.length > 0
      ? data
      : {
          nominees: [
            {
              nomineeDetails: {
                name: '',
                relationShip: '',
                dateOfBirth: '',
              },
              share: '',
              isMinor: false,
              guardian: {},
            },
          ],
          acceptedNomineeTerms: false,
        };

  const Header = () => (
    <div>
      <StyledH6>{constants.ADD_NOMINEE}</StyledH6>
    </div>
  );

  const validationSchema = yup.object({
    nominees: yup
      .array()
      .of(
        yup.object().shape({
          nomineeDetails: nomineeDetailsValidation(accountHolder),
          share: nomineeCount > 0 ? yup.string().required(ErrorMessage.SHARE_ERROR) : yup.string().notRequired(), //share field is required only if we have more than 1 nominees
          guardian: yup
            .object()
            .when('isMinor', {
              is: true,
              then: guardianDetailsValidation(),
              otherwise: yup.object().notRequired(),
            })
            .nullable(true),
        })
      )
      .max(maxNominee, 'You cant add more than 3 nominee')
      .required('Required'),
  });

  const validateShare = (nominees) => {
    let totalShare = 0;
    nominees?.map((values, index) => {
      totalShare += Number(values.share);
    });
    if (nominees.length > 1) {
      if (totalShare > 100) {
        setErrorMessageShownInModal(ErrorMessage.TOTAL_NOMINEE_SHARE_VALUE_GREATER_THAN_100);
        setOpenErrorModal(true);
        return false;
      } else if (totalShare < 100) {
        setErrorMessageShownInModal(ErrorMessage.TOTAL_NOMINEE_SHARE_VALUE_LESS_THAN_100);
        setOpenErrorModal(true);
        return false;
      }
    }
    return true;
  };
  const handleShowGuardian = (
    handleChange: Function,
    fieldName: string,
    dateOfBirth: any,
    isNominee: boolean,
    values: any,
    index: number,
    setFieldValue: Function,
    setFieldError: Function,
    setFieldTouched: Function
  ) => {
    // const dateOfBirth = moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY');
    const event = {
      target: {
        name: fieldName,
        value: dateOfBirth,
      },
    };
    if (dateOfBirth !== '' && !isNominee && isMinor(dateOfBirth, !isNominee)) {
      setErrorMessageShownInModal(ErrorMessage.GUARDIAN_AGE_LESS_THAN_18_ERROR);
      setOpenErrorModal(true);
    } else {
      handleChange(event);
    }

    if (isNominee) {
      let years = moment().diff(dateOfBirth, 'years');
      if (years < 18) {
        if (Object.keys(values?.nominees[index]?.guardian).length === 0) {
          setFieldValue(`nominees.${index}.guardian`, {
            name: '',
            relationShip: '',
            dateOfBirth: '',
          });

          setFieldTouched(`nominees.${index}.guardian`, false);
          setFieldError(`nominees.${index}.guardian`, {});
        }
        setFieldValue(`nominees.${index}.isMinor`, true);
      } else {
        setFieldValue(`nominees.${index}`, {
          nomineeDetails: values?.nominees[index]?.nomineeDetails,
          share: values?.nominees[index]?.share,
          guardian: {},
          isMinor: false,
        });
        setFieldTouched(`nominees.${index}.guardian`, false);
        setFieldError(`nominees.${index}.guardian`, {});
        // setFieldValue(`nominees.${index}.isMinor`, false);
        const event = {
          target: {
            name: fieldName,
            value: dateOfBirth,
          },
        };
        handleChange(event);
      }
    }
  };

  return (
    <NomineeModalWrapper>
      {openErrorModal && (
        <StyledAlertModal
          className="alert-modal"
          wrapperClassname="alert-modal-wrapper"
          contentClassname="alert-modal-content"
          onClose={() => setOpenErrorModal(false)}
          mode="alert"
          showHeader={false}
        >
          <StyledP1 dangerouslySetInnerHTML={{ __html: errorMessageShownInModal }} />
        </StyledAlertModal>
      )}
      {isOpen && (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if (validateShare(values.nominees)) {
              let nomineesData = values?.nominees;
              if (nomineesData?.length === 1) {
                nomineesData[0].share = 100;
              }
              const data = { nominees: nomineesData, acceptedNomineeTerms: values?.acceptedNomineeTerms };
              onNomineeDetailsSubmit(data);
              onCloseModal(false);
            }
          }}
        >
          {({
            values,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            touched,
            setFieldError,
            setFieldTouched,
          }) => (
            <StyledModal
              id="nominee-modal"
              // mode="normal"
              // onClose={() => {
              //   setNomineeDeclarationOptInError(false);
              //   setNomineeDetailsPresent('');
              //   onCloseModal(false);
              // }}
              // HeaderComponent={Header()}
              className="nominee-modal"
              // FooterComponent={Footer(
              //   values,
              //   handleChange,
              //   handleSubmit,
              //   setNomineeDeclarationOptInChecked,
              //   nomineeDeclarationOptInChecked,
              //   setNomineeDeclarationOptInError,
              //   nomineeDeclarationOptInError,
              //   fundHouseId
              // )}
            >
              <NomineeModalContainer>
                <HeaderName>{Header()}</HeaderName>
                <Form>
                  <FieldArray name="nominees">
                    {({ insert, remove, push }) => (
                      <div>
                        {values?.nominees?.length > 0 &&
                          values?.nominees?.map((nominee, index) => (
                            <NomineeDetailsWrapper key={index}>
                              <NomineeCounterWrapper>
                                <NomineeCounterContainer>
                                  <CounterWrapper>
                                    <StyledB1>{index + 1}</StyledB1>
                                  </CounterWrapper>
                                  <StyledB1>{constants.NOMINEE}</StyledB1>
                                </NomineeCounterContainer>
                                {values?.nominees?.length > 1 && (
                                  <StyledLinkedLabel
                                    onClick={() => {
                                      onRemoveNomineeClick();
                                      if (index === 0 && values?.nominees?.length === 2) {
                                        // this condition is invoked, for when we already have 1 nominee
                                        /* click on  Add a Nominee
                                           Click on Edit.
                                           Click Add another Nominee
                                           Remove the previously added nominee
                                           Click on Confirm details -> confirm wont work, as formik has set an error in the share field
                                           to reset that we set its value as 100                                        
                                        */
                                        setFieldValue(`nominees.${1}.share`, 100);
                                      }
                                      if (index - 1 === 0 && values?.nominees?.length === 2) {
                                        // this condition is used when we have only 2 nominee details,
                                        // and we delete 1 nominee, then we need to auto set the other nominees share value as 100
                                        setFieldValue(`nominees.${0}.share`, 100);
                                      }
                                      remove(index);
                                    }}
                                  >
                                    Remove
                                  </StyledLinkedLabel>
                                )}
                              </NomineeCounterWrapper>
                              {NomineeDetails(
                                true,
                                index,
                                values,
                                errors,
                                handleChange,
                                handleBlur,
                                handleShowGuardian,
                                values.nominees.length,
                                setFieldValue,
                                touched,
                                accountHolder,
                                setFieldError,
                                setFieldTouched,
                                setOpenErrorModal,
                                setErrorMessageShownInModal,
                                relationShipCodeDetails,
                                relationShipCodeObject
                              )}
                              {values?.nominees[index]?.guardian &&
                              Object.keys(values?.nominees[index]?.guardian)?.length !== 0 &&
                              values?.nominees[index]?.guardian?.constructor === Object ? (
                                <GuardianDetailWrapper>
                                  <GuardianDetailTitleWrapper>
                                    <StyledB1>{constants.ENTER_GUARDIAN_NAME}</StyledB1>
                                    <HighlightP2>{constants.GUARDIAN}</HighlightP2>
                                  </GuardianDetailTitleWrapper>
                                  {NomineeDetails(
                                    false,
                                    index,
                                    values,
                                    errors,
                                    handleChange,
                                    handleBlur,
                                    handleShowGuardian,
                                    values.nominees.length,
                                    setFieldValue,
                                    touched,
                                    accountHolder,
                                    setFieldError,
                                    setFieldTouched,
                                    setOpenErrorModal,
                                    setErrorMessageShownInModal,
                                    relationShipCodeDetails,
                                    relationShipCodeObject
                                  )}
                                </GuardianDetailWrapper>
                              ) : (
                                ''
                              )}
                            </NomineeDetailsWrapper>
                          ))}
                        {typeof errors.nominees === 'string' ? <div>{errors.nominees}</div> : null}
                        <AddAnotherNomineeWrapper disabled={values?.nominees?.length === maxNominee ? true : false}>
                          <StyledPlusBurgundySvg />
                          <StyledLinkLabel
                            onClick={() => {
                              onAddNomineeClick();
                              if (values?.nominees?.length < maxNominee) {
                                setNomineeCount(values?.nominees?.length + 1);
                                if (values?.nominees?.length === 1) {
                                  setFieldValue(`nominees.${0}.share`, '', false);
                                  setFieldTouched(`nominees.${0}.share`, false);
                                }
                                push({
                                  nomineeDetails: {
                                    name: '',
                                    relationShip: '',
                                    dateOfBirth: '',
                                  },
                                  share: '',
                                  isMinor: false,
                                  guardian: {},
                                });
                              }
                            }}
                          >
                            {constants.ADD_ANOTHER_NOMINEE}
                          </StyledLinkLabel>
                        </AddAnotherNomineeWrapper>
                      </div>
                    )}
                  </FieldArray>
                  {typeof errors.nominees === 'string' ? <div>{errors.nominees}</div> : null}
                </Form>
                <StyledFooter>
                  {Footer(
                    values,
                    handleChange,
                    handleSubmit,
                    setNomineeDeclarationOptInChecked,
                    nomineeDeclarationOptInChecked,
                    setNomineeDeclarationOptInError,
                    nomineeDeclarationOptInError,
                    fundHouseId,
                    shouldSendOtp,
                    setIsModalOpen
                  )}
                </StyledFooter>
              </NomineeModalContainer>
            </StyledModal>
          )}
        </Formik>
      )}
    </NomineeModalWrapper>
  );
}

const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${up('md')} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
`;
const NomineeModalWrapper = styled.div`
  position: relative;
  overflow: auto;
`;

const StyledP1 = styled(P1)`
  color: ${(props) => props.theme.palette.grey2};
`;

const NomineeModalContainer = styled.div`
  padding-top: 0;
  height: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
  ${up('md')} {
    padding-top: 0;
    height: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1rem;
  }
`;

const StyledField = styled(Field)`
  font-family: Lato;
  font-style: italic;
  color: ${(props) => props.theme.palette.burgundy2};
`;
const StyledInput = styled(Input)`
  min-height: 0;
  ${up('md')} {
    min-height: 0;
  }
`;
const StyledModal = styled.div`
  &.nominee-modal-body {
    padding-bottom: 0;
  }
`;

const NomineeDetailsWrapper = styled.article`
  display: flex;
  flex-direction: column;
`;

const NomineeDetailWrapper = styled.article`
  display: flex;
  flex-direction: column;
  ${up('md')} {
    display: flex;
    flex-flow: row wrap;
  }
`;

const NomineeCounterWrapper = styled.article`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${pxToRem(20)};
`;

const NomineeCounterContainer = styled.article`
  display: flex;
`;

const GuardianDetailTitleWrapper = styled.article`
  display: flex;
  padding-bottom: ${pxToRem(8)};
`;

const HighlightP2 = styled(P2)`
  background-color: #ed11641a;
  border-radius: ${pxToRem(8)};
  width: auto;
  opacity: 100%;
  color: ${(props) => props.theme.palette.burgundy1};
  padding: ${pxToRem(2)} ${pxToRem(8)};
  margin-left: ${pxToRem(8)};
`;
const StyledB1 = styled(B1)`
  color: ${(props) => props.theme.palette.grey2};
`;

const StyledButton = styled(Button)`
  width: 100%;
  margin-top: ${pxToRem(16)};
  ${up('md')} {
    width: ${pxToRem(160)};
    margin-top: 0;
  }
`;
const StyledH6 = styled(H6)`
  color: #4a4a4a;
`;

const StyledP2 = styled(P2)`
  color: #6d6e71;
`;

const GuardianDetailWrapper = styled.article`
  display: flex;
  flex-direction: column;
`;

const CounterWrapper = styled.article`
  background-color: #f0f0f0;
  border-radius: ${pxToRem(160)};
  padding: ${pxToRem(2)} ${pxToRem(8)};
  margin-right: ${pxToRem(12)};
`;

const StyledLinkedLabel = styled(P2)`
  color: ${(props) => props.theme.palette.burgundy1};
  cursor: pointer;
`;

const StyledLinkLabel = styled(P1)<{ disabled: boolean }>`
  color: ${(props) => props.theme.palette.burgundy1};
  cursor: pointer;
  padding-left: ${pxToRem(8)};
`;

const InputWrapper = styled.article<{ enable: boolean; addLeftPadding?: boolean; addRightPadding?: boolean }>`
  display: ${(props) => (props.enable ? 'inline-block' : 'none')};
  padding-top: ${pxToRem(4)};
  padding-bottom: ${pxToRem(12)};
  ${up('md')} {
    flex: 50%;
    padding-top: ${pxToRem(8)};
    padding-left: ${(props) => (props.addLeftPadding ? `${pxToRem(32)}` : '0')};
    padding-right: ${(props) => (props.addRightPadding ? `${pxToRem(32)}` : '0')};
    /* padding-right: ${pxToRem(32)}; */
  }
`;

const SelectDropDownWrapper = styled.article<{ reduceWidth?: boolean; addLeftPadding?: boolean }>`
  padding-bottom: ${pxToRem(20)};
  ${up('md')} {
    flex: 50%;
    padding-left: ${pxToRem(32)};
  }
`;

const DateWrapper = styled.article`
  padding-bottom: ${pxToRem(16)};
  position: relative;
  ${up('md')} {
    flex: 50%;
    padding-top: ${pxToRem(8)};
    padding-right: ${pxToRem(32)};
    max-width: 50%;
  }
`;

const MinorLabelWrapper = styled.div<{ enable: boolean }>`
  position: absolute;
  top: 0;
  left: ${pxToRem(72)};
  display: ${(props) => (props.enable ? 'inline-block' : 'none')};
  ${up('md')} {
    top: ${pxToRem(6)};
    left: ${pxToRem(88)};
  }
`;
const StyledCheckBox = styled(CheckBox)`
  padding-left: ${pxToRem(4)};
  ${up('md')} {
    padding-left: 0;
  }
`;

const AddAnotherNomineeWrapper = styled.div<{ disabled: boolean }>`
  display: ${(props) => (props.disabled ? 'none' : 'flex')};
`;

const StyledPlusBurgundySvg = styled(PlusBurgundy)`
  ${up('md')} {
    padding-top: ${pxToRem(2)};
    padding-left: ${pxToRem(2)};
  }
`;

const NewNomineeDeclarationMessageWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;
const NomineeDeclarationOptOutAccordionText = styled(P1)``;

const StyledErrorMessage = styled(P2)`
  color: ${(props) => props.theme.palette.red1};
  padding: 0;
  margin: 0;
  font-style: italic;
  margin-block-end: 0;
  margin-block-start: 0;
`;

const NominationDeclarationErrorMessage = styled(P2)`
  width: 100%;
  margin: 0.3rem 0 0 0;
`;

const HeaderName = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
`;

const StyledFooter = styled.div`
  padding-top: 20px;
`;
